import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './PlanDuSite.css';

const PlanDuSite = () => {
  return (
    <>
      <Helmet>
        <title>Plan du site et Mentions légales - Excellence Informatique</title>
        <meta name="description" content="Plan du site Excellence Informatique - Dépannage informatique à Nantes et Loire-Atlantique. Mentions légales et informations légales." />
        <meta name="keywords" content="plan du site, mentions légales, Excellence Informatique, Nantes, Loire-Atlantique, dépannage informatique" />
      </Helmet>
      
      <div className="page-content">
        <div className="container">
          <article className="page-article">
            <div className="entry-content">
              <h1>Plan du site et Mentions légales – Excellence Informatique à Nantes</h1>
              
              <div className="sitemap-section">
                <h2>Plan du site</h2>
                
                <div className="sitemap-main">
                  <h3><Link to="/">Accueil</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/">Dépannage informatique à domicile à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/accueil-new/">Services de dépannage informatique professionnels à Nantes</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/pc/">Dépannage PC à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/reparation/informatique/">Réparation informatique professionnelle à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/ordinateur/">Dépannage Informatique Professionnel à Nantes pour votre Ordinateur en Panne</Link></h3>
                  
                  <h3><Link to="/reparation/pc/">Dépannage et réparation informatique professionnelle à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/domaines/cours/">Formation informatique personnalisée pour maîtriser votre ordinateur</Link></h3>
                  
                  <h3><Link to="/reparation/ordinateur/">Service de réparation d'ordinateurs à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/ordinateur/reparation/">Réparation professionnelle d'ordinateurs portables et tablettes à Nantes</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/forfaits/windows/">Dépannage informatique Windows à Nantes</Link></h3>
                  
                  <h3><Link to="/ordinateur/imprimante/">Problèmes d'imprimante ? Faites appel à Excellence Informatique à Nantes</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/loire-atlantique/">Services de dépannage informatique en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/forfaits/urgence/">Dépannage de PC à domicile en urgence</Link></h3>
                  
                  <h3><Link to="/depannage-informatique/">Dépannage informatique</Link></h3>
                  
                  <h3><Link to="/reconditionnement-dordinateur/">Reconditionnement d'ordinateur</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/diagnostic/assistance/">Assistance informatique à Nantes et en Loire-Atlantique (44)</Link></h3>
                  
                  <h3><Link to="/micro-soudure-et-plasturgie/">Micro-soudure et plasturgie</Link></h3>
                  
                  <h3><Link to="/reparation/domicile/">Réparateur à domicile à Nantes</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/diagnostic/technicien/">Appelez notre technicien informatique</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/forfaits/formation/">Dépannage PC et formation informatique</Link></h3>
                  
                  <h3><Link to="/recuperation-de-donnees/">Récupération de données</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/loire-atlantique/bureautique/">Formation bureautique, Email, recherche sur internet</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/diagnostic/aide/">Besoin d'Aide en informatique</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/domaines/">Nos domaines d'expertise en Loire Atlantique</Link></h3>
                  
                  <h3><Link to="/accueil/domicile/ordinateur/zone/">Notre zone d'intervention en Loire Atlantique</Link></h3>
                  
                  <h3><Link to="/accueil/maxime-huet-technicien-en-depannage-informatique/">Mehdi laid - Technicien en dépannage informatique</Link></h3>
                </div>
              </div>

              <div className="legal-section">
                <h2>Mentions légales</h2>
                
                <p>
                  Nous vous remercions de votre visite sur le site <strong>Excellence Informatique</strong>. 
                  La consultation de ce site internet suppose l'acceptation sans réserve des présentes conditions d'utilisation.
                </p>
                
                <h3>Propriétaire du site</h3>
                <p>
                  <strong>Excellence Informatique</strong><br />
                  Technicien : Mehdi laid<br />
                  Téléphone : 07 45 39 09 63<br />
                  Zone d'intervention : Nantes et Loire-Atlantique (44)
                </p>
                
                <h3>Développement et Maintenance</h3>
                <p>
                  Le site est développé et maintenu par : <strong>Mehdi laid</strong><br />
                  Contact technique : 07 45 39 09 63
                </p>
                
                <h3>Hébergement</h3>
                <p>
                  Le site est hébergé en France sur les serveurs de la société :<br />
                  <strong>O2 Switch</strong><br />
                  Société : O2 Switch<br />
                  Adresse web : www.o2switch.fr<br />
                  Adresse Postale : 222-224 Boulevard Gustave Flaubert<br />
                  63000 Clermont-Ferrand<br />
                  Téléphone : 04 44 44 60 40<br />
                  Adresse électronique : support@o2switch.fr
                </p>
                
                <h3>Politique de confidentialité</h3>
                <p>
                  Nous nous engageons à protéger vos données personnelles. Les informations collectées 
                  sur ce site sont utilisées uniquement dans le cadre de nos services de dépannage informatique 
                  et ne sont jamais transmises à des tiers sans votre consentement explicite.
                </p>
                
                <h3>Droit d'auteur</h3>
                <p>
                  L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur 
                  et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour 
                  les documents téléchargeables et les représentations iconographiques et photographiques.
                </p>
                
                <h3>Contact</h3>
                <p>
                  Pour toute question concernant ce site ou nos services, vous pouvez nous contacter :<br />
                  Téléphone : 07 45 39 09 63<br />
                  Zone d'intervention : Nantes et Loire-Atlantique (44)
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default PlanDuSite;
